(function() {
  'use strict';

  angular.module('ringbaPortal').directive('lightDarkThemeEditorToggle', lightDarkThemeEditorToggle);

  function lightDarkThemeEditorToggle(

  ) {
    'ngInject';

    const directive = {
      restrict: 'E',
      scope: {
        isLightTheme: '<',
        onChange: '&'
      },
      link: link,
      templateUrl: '/scripts/shared/directives/light-dark-theme-editor-toggle/light-dark-theme-editor-toggle.view.html'
    };
    return directive;

    function link(scope) {
      scope.onThemeToggle = onThemeToggle;


      function onThemeToggle(isLightTheme) {
        scope.onChange({
          isLightTheme: isLightTheme
        });
      }
    }

  }

})();
